import React from 'react'
import { Select } from 'antd'

import CustomInput from '../../../components/Input/Input'

import { labelClassNames } from './index'
import { INTERNAL_KEY_STATUS_OPTIONS } from '../utils'

let timeOut = null

function InternalKeysFields (props) {
  const { filters, setFilters, searchValue, setSearchValue } = props

  return (
    <>
      <div className="w-[200px]">
        <div className={labelClassNames}>
          Search internal key
        </div>

        <CustomInput
          placeholder="Search"
          value={searchValue}
          allowClear
          onChange={(e) => {
            setSearchValue(e.target.value)

            if (timeOut) {
              clearTimeout(timeOut)
            }
            timeOut = setTimeout(() => {
              setFilters(prev => ({
                ...prev,
                searchInternalKey: e.target.value
              }))
            }, 600)
          }}
        />
      </div>

      <div className="w-[200px]">
        <div className={labelClassNames}>
          Box
        </div>

        <Select
          className="w-full"
          placeholder="Select box"
          options={[
            { label: 'Box 1', value: 'Box 1'},
            { label: 'Box 2', value: 'Box 2'},
            { label: 'Box 3', value: 'Box 3'}
          ]}
          value={filters.boxType}
          onChange={value => {
            setFilters(prev => ({
              ...prev,
              boxType: value
            }))
          }}
          allowClear
        />
      </div>

      <div className="w-[200px]">
        <div className={labelClassNames}>
          Internal key status
        </div>

        <Select
          className="w-full"
          placeholder="Select status"
          options={INTERNAL_KEY_STATUS_OPTIONS}
          value={filters.internalKeyStatus}
          onChange={value => {
            setFilters(prev => ({
              ...prev,
              internalKeyStatus: value
            }))
          }}
          allowClear
        />
      </div>
    </>
  )
}

export default InternalKeysFields